const targets: string[] = [
  'https://sd.iadvize.com',
  'https://ha.iadvize.com',
  'https://app.iadvize.com',
  'https://app.iadvize.com',
  'https://ibbu.iadvize.com',
];

type InitCommand = {
  action: 'com.iadvize.desk.INIT';
  version: '2.1.0';
};

type InsertTextInComposeBoxCommand = {
  action: 'com.iadvize.desk.INSERT_TEXT_IN_COMPOSE_BOX';
  content: string;
};

type Command = InsertTextInComposeBoxCommand | InitCommand;

type CPAInitialised = {
  event: 'com.iadvize.desk.INITIALISED';
  conversationId: string;
  projectId: string;
  language?: string;
};

type Context = {
  conversationId: string;
  projectId: string;
  language: string;
};

export interface Client {
  context: Context;
  insertTextInComposeBox: (message: string) => void;
}

type CommandSender = (command: Command) => void;
type EvenReceiver = {
  addEventListener: (listener: (event: any) => void) => void;
};

type Dependencies = {
  commandSender: CommandSender;
  eventReceiver: EvenReceiver;
};

let mobileEventListener: (jsonMessage: string) => void;

export const postMessage = (jsonMessage: string) => {
  mobileEventListener(jsonMessage);
};

const dependencies: Dependencies = {
  commandSender: (command: Command) => {
    const mobileMsgBus =
      (window as any).iAdvizeAndroidMsgBus ||
      (window as any).webkit?.messageHandlers?.iAdvizeMsgBus;
    if (mobileMsgBus) {
      mobileMsgBus.postMessage(JSON.stringify(command));
    } else {
      targets.forEach(target => {
        window.parent.postMessage(command, target);
      });
    }
  },
  eventReceiver: {
    addEventListener: listener => {
      (window as any).addEventListener('message', listener, false);
      mobileEventListener = message => {
        listener({ data: JSON.parse(message) });
      };
    },
  },
};

export const init = ({
  commandSender,
  eventReceiver,
}: Dependencies = dependencies): Promise<Client> => {
  const clientPromise = new Promise<Client>(resolve => {
    const receiveEvent = (event: any) => {
      if (event.data?.event === 'com.iadvize.desk.INITIALISED') {
        const {
          conversationId,
          projectId,
          language,
        }: CPAInitialised = event.data as CPAInitialised;
        resolve({
          context: {
            conversationId,
            projectId,
            language: language || navigator.language, // rfc5646
          },
          insertTextInComposeBox: (message: string) => {
            commandSender({
              action: 'com.iadvize.desk.INSERT_TEXT_IN_COMPOSE_BOX',
              content: message,
            });
          },
        });
      }
    };
    eventReceiver.addEventListener(receiveEvent);
  });

  commandSender({
    action: 'com.iadvize.desk.INIT',
    version: '2.1.0',
  });

  return clientPromise;
};
